// extracted by mini-css-extract-plugin
export default {"results-section":"CalculadoraDemanda_results-section__jWYzu","charts-flex":"CalculadoraDemanda_charts-flex__H28zL"};